// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1ZdOf","header":"PatientBlock_header__1cB5I","label":"PatientBlock_label__1alG3","option":"PatientBlock_option__2qKE0"};